import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLinkOutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path
      fill="#000000"
      d="M9.75 12H1.5A1.5 1.5 0 0 1 0 10.5V2.25A1.5 1.5 0 0 1 1.5.75h3v1.5h-3v8.25h8.25v-3h1.5v3a1.5 1.5 0 0 1-1.5 1.5ZM5.775 7.28 4.717 6.22l4.72-4.72H6.75V0H12v5.25h-1.5V2.561l-4.725 4.72Z"
    />
  </svg>
);
export default SvgLinkOutIcon;
